// eslint-disable-next-line import/prefer-default-export
export const feedbackTypes = {
  0: 'Pickup',
  1: 'Sauce Delivery'
};
